import Requests from '@/helpers/Request';
import Vue from 'vue';
import { toJson, eventlist, groupByHorizontalPages, getEpgForPage, highlightFirstProgram, sortAndFilterChannels, addPageNrToChannels } from '@/helpers/EpgGuide'

// Gibt kurz die Kontrolle an den Event-Loop zurueck, damit Key-Events
// und Router-Navigationen zwischen CPU-Bursts laufen koennen.
function yieldToEventLoop() {
  return new Promise((resolve) => setTimeout(resolve, 0));
}

// map(), aber mit Yield nach jedem Element. Auf langsamer TV-Hardware
// reicht das, um den Main-Thread zwischen den XML-Walks kurz freizugeben.
async function mapChunked(items, fn) {
  const out = new Array(items.length);
  for (let i = 0; i < items.length; i++) {
    out[i] = fn(items[i], i, items);
    if (i < items.length - 1) await yieldToEventLoop();
  }
  return out;
}

export default {
  namespaced: true,
  state: () => ({
    tvPackageLoaded: false,
    tvPackageData: {},
    tvChannelData: {}, // obsolete
    tvChannels: [],
    pool: [],
    programs: [], // for current page
    programsByPages: [],
    tvStartChannel: 0,
    isLoading: false,
    initPromise: null
  }),
  mutations: {
    tvPackage(state, tvPackageData) {
      state.tvPackageData = tvPackageData;
    },
    tvChannels(state, {channels}) {
      for (const item of channels) {
        if (item.serviceType !== "tv") continue;
        Vue.set(state.tvChannelData, item.position, item);
      }
    },
    tvChannelsSort(state, channels) {
      state.tvChannels = addPageNrToChannels(sortAndFilterChannels(channels));
    },
    // contains 15h epg data
    epgPool(state, pool) {
      state.pool = pool;
    },
    programs(state, programs) {
      state.programs = programs;
    },
    programsByPages(state, programsByPages) {
      state.programsByPages = programsByPages;
    },
    tvStartChannel(state, tvStartChannel) {
      state.tvStartChannel = tvStartChannel;
    },
    setLoading(state, value) {
      state.isLoading = !!value;
    },
    setInitPromise(state, promise) {
      state.initPromise = promise;
    },
  },
  actions: {
    init({ commit, dispatch, rootState, state }) {
      // Re-Entrancy-Schutz: laeuft bereits ein Init, liefern wir dasselbe
      // Promise zurueck. Verhindert Doppel-Fetch, wenn Home.vue beim
      // Rueck-Navigieren erneut mounted und init nochmal dispatcht,
      // waehrend der erste Lauf noch laeuft.
      if (state.isLoading && state.initPromise) {
        return state.initPromise;
      }

      const run = (async () => {
        try {
          const response = await Requests.fetchTvPackages({
            deviceId: rootState.deviceId
          });
          commit('tvPackage', response);
          commit('tvChannels', response.package) // obsolete
          commit('tvChannelsSort', response.package)

          // Parallel-Fetch aller Kanal-EPGs (siehe Request.fetchEpgByChannels)
          const responseEpg = await Requests.fetchEpgByChannels({
            channels: state.tvChannels
          });

          // Drei CPU-Bursts (toJson/groupByHorizontalPages/eventlist) pro Kanal
          // gechunkt mit Yield zum Event-Loop. Ohne das blockiert das
          // synchrone DOM-Walking auf LG WebOS den Main-Thread so lange,
          // dass Key-Events nicht durchkommen.
          const epgJson = await mapChunked(responseEpg, (item) => toJson(item));
          commit('epgPool', epgJson);

          commit('programsByPages', []);
          const now = new Date();
          const programsByPages = await mapChunked(epgJson, (epg, index) => groupByHorizontalPages(epg, index, now));
          commit('programsByPages', programsByPages);

          const p1 = getEpgForPage(1, programsByPages);
          const epgPage1 = await mapChunked(p1, (epg, index) => eventlist(epg, index, 1));

          highlightFirstProgram(epgPage1, state.tvStartChannel);

          console.log("epgPage1: ", epgPage1);
          commit('programs', []);
          commit('programs', epgPage1);
        } catch (err) {
          console.log("Error in init epg guide: ", err);
          throw err;
        } finally {
          commit('setLoading', false);
          commit('setInitPromise', null);
        }
      })();

      commit('setLoading', true);
      commit('setInitPromise', run);
      return run;
    },
  },
  getters: {
    tvChannels(state) {
      console.log('state tvChannels', state)
      return state.tvChannels;
    },
    tvPrograms(state) {
      console.log('state tvPrograms', state)
      return state.programs;
    },
    tvStartChannel(state) {
      return state.tvStartChannel;
    }
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/epg-guide.js